export default {"src":"/_next/static/media/author.124088f9.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};